import React from 'react';

const AlertMessage = ({ type = 'success', message, onClose }) => {
	if (!message) return null;
	type = type === 'error' ? 'danger' : type; // Map 'error' to 'danger' for Bootstrap

	return (
		<div className={`alert alert-${type} alert-dismissible fade show`} role="alert">
			{message}
			<button type="button" className="btn-close" aria-label="Close" onClick={onClose}></button>
		</div>
	);
};

export default AlertMessage;